<template>
  <div class="access-control">
    <a-spin :spinning="rebootLoading" tip="设备正在重启中..." size="large">
      <public-bread-crumb :routes="routes" />
      <public-top-bar
        placeholder="请输入机构名称、固件版本、SN码"
        :topBarBtns="topBarBtns"
        :onTableSearchFun="onTableSearchFun"
        @changeBasicSearchFun="changeBasicSearchFun"
        :ifShowHighFlag="true"
        :resetSearch="resetSearch"
        @unresetSearchFun="unresetSearchFun"
      >
        <template v-slot:highSearchGroup>
          <a-select
            placeholder="请选择接入的防疫平台"
            class="top-bar-input"
            allowClear
            v-model="searchObj.healthCodeType"
          >
            <!-- <a-select-option value="">全部</a-select-option> -->
            <a-select-option
              v-for="(i, index) in healthCodeTypeSelect"
              :key="index"
              :value="i.ind"
              >{{ i.value }}</a-select-option
            >
          </a-select>
          <a-select
            placeholder="请选择设备状态"
            class="top-bar-input"
            allowClear
            v-model="searchObj.status"
          >
            <a-select-option value="">全部</a-select-option>
            <a-select-option
              v-for="(i, index) in stateSelects"
              :key="index"
              :value="i.ind"
              >{{ i.value }}</a-select-option
            >
          </a-select>
        </template></public-top-bar
      >
      <public-table
        rowKey="sn"
        :columns="columns"
        :operateA="operateA"
        :operateWidth="operateWidth"
        :tableData="tableData"
        :tableInfo="tableInfo"
        :tableLoading="tableLoading"
        @selectTableRowFun="selectTableRowFun"
        @sortChangeFun="tableSorterFun"
      >
        <!-- 设备状态 -->
        <template slot="state" slot-scope="scope">
          <span>{{ scope.row.state ? "在线" : "离线" }}</span>
        </template>
        <!-- 设备型号 -->
        <!-- <template slot="deviceType" slot-scope="scope">
          <span>{{ scope.row.deviceType }}</span>
        </template> -->
        <!-- 故障监测 -->
        <template slot="instruc" slot-scope="scope">
          <span :style="{ color: scope.row.instruc ? 'red' : '#333' }">{{
            scope.row.instruc ? "异常" : "正常"
          }}</span>
        </template>
      </public-table>
      <!-- 升级弹窗 this.updateServices.listServices-->
      <a-modal
        v-model="modalShow"
        title="选择升级包"
        width="342px"
        class="update-modal"
        centered
        :closable="false"
      >
        <public-update
          v-if="modalShow"
          type="门禁设备"
          :updateServices="this.updateServices"
          :modalShow="modalShow"
          @closeUpdate="closeUpdate"
          @checkedVersion="checkedVersion"
        />
        <template slot="footer">
          <a-button
            key="back"
            type="primary"
            class="footer-btn"
            :loading="updateLoading"
            @click="updateMe"
            >确定</a-button
          >
          <a-button
            key="submit"
            @click="closeUpdate"
            class="footer-btn"
            style="margin-right: 0; background: #ecedff"
            >取消</a-button
          >
        </template>
      </a-modal>
      <!-- 故障状态弹窗 -->
      <public-status ref="statusWeight" />
    </a-spin>
  </div>
</template>

<script>
import { devicePublic, publicTableList } from "@/mixins/mixinsData";
import ACServices from "@/services/accessControl.services";
import DeviceServices from "@/services/deviceCommon.services";

export default {
  name: "AccessControl",
  mixins: [devicePublic, publicTableList],
  data() {
    return {
      resetSearch: false,
      topBarBtns: [
        {
          name: "重置",
          type: "primary",
          fun: this.resetSearchFun
        }
      ],
      healthCodeTypeSelect: [
        { ind: "", value: "全部" },
        { ind: "1", value: "陕西一码通" },
        { ind: "4", value: "宝鸡纳管" },
        { ind: "5", value: "西安纳管" }
      ],
      stateSelects: [
        { ind: "true", value: "在线" },
        { ind: "false", value: "离线" }
      ],
      routes: [
        {
          name: "手持设备管理",
          path: "/handle-control"
        }
      ],
      operateA: [
        {
          name: "一码通设置",
          fun: this.addPageOrEditPage
        }
        //   {
        //     name: "删除",
        //     fun: this.rowDel,
        //   },
      ],
      operateWidth: 140,
      columns: [
        {
          title: "机构名称",
          dataIndex: "areaName",
          type: "tooltip",
          width: 150
        },
        {
          title: "设备名称",
          dataIndex: "name",
          width: 220,
          type: "tooltip"
        },
        {
          title: "设备型号",
          dataIndex: "deviceType",
          // custom: true,
          width: 165,
          type: "tooltip"
        },
        {
          title: "设备状态",
          dataIndex: "state",
          sorter: true,
          custom: true,
          width: 176
        },
        {
          title: "SN码",
          dataIndex: "sn",
          width: 225,
          type: "tooltip"
        },
        {
          title: "本地IP",
          dataIndex: "ip",
          width: 220
        },
        {
          title: "固件版本",
          dataIndex: "version"
        }
      ]
    };
  },
  mounted() {
    // 获取门禁设备列表
    this.getTableData(ACServices.GetHandheldEquListByPgae);

    // 故障状态Api
    this.statusServices = ACServices.GetStatus;

    // 重启设备Api
    this.rebootServices = DeviceServices.RebootDevices;

    // 升级Api
    this.updateServices = {
      listServices: DeviceServices.GetVersionTable,
      updateApi: DeviceServices.UpdateVersion
    };
  },
  methods: {
    // 编辑?新增?
    addPageOrEditPage(item) {
      if (item && item.sn) {
        this.$router.push(`/handle/onecode?id=${item.sn}`);
      }
    }
    // 升级
    // okUpdateVersion () {
    //   this.updateMe('/access-control')
    // }
  }
};
</script>

<style lang="less">
.top-bar-input {
  width: 396px;
  margin-right: 24px;
}
.update-modal {
  height: 439px;
  .ant-modal-content {
    .ant-modal-header {
      height: 53px;
      padding: 16px 0;
      text-align: center;
    }
    .ant-modal-body {
      height: 320px;
      padding: 16px 16px 0;
    }
    .ant-modal-footer {
      height: 64px;
      padding: 16px;
      text-align: center;
    }
  }
  .footer-btn {
    width: 88px;
    height: 32px;
    margin-right: 32px;
    border-radius: 3px;
    border: 0px;
  }
}
</style>
